export class FieldStatusManager {
    public static FIELDS_LISTED = 'FIELDS_LISTED';
    public static FIELD_GET = 'FIELD_GET';
    public static FIELD_BY_SPORT = 'FIELD_BY_SPORT';
    public static LIST_FIELD = 'LIST_FIELD';
    public static FIELD_BY_ID = 'FIELD_BY_ID';
    public static FIELD_SLOTS_AVAILABLE_GETED = 'FIELD_SLOTS_AVAILABLE_GETED';
    public static SLIDER_FIELDS_SLOTS_AVAILABLE = 'SLIDER_FIELDS_SLOTS_AVAILABLE';
}

export class ReservationsStatusManager {
    public static RESERVATIONS_LISTED = 'RESERVATIONS_LISTED';
    public static RESERVATION_GET = 'RESERVATION_GET';
    public static RESERVATION_BY_SPORT = 'RESERVATION_BY_SPORT';
    public static LIST_RESERVATION = 'LIST_RESERVATION';
    public static RESERVATION_BY_ID = 'RESERVATION_BY_ID';
    public static RESERVATION_SLOTS_AVAILABLE_GETED = 'RESERVATION_SLOTS_AVAILABLE_GETED';
}

export class PricesStatusManager {
    public static PRICES_LISTED = 'PRICES_LISTED';
    public static PRICE_GET = 'PRICE_GET';
    public static LIST_PRICE = 'LIST_PRICE';
    public static PRICES_BY_IDS = 'PRICES_BY_IDS';
    public static FIELD_SLOTS_PRICES = 'FIELD_SLOTS_PRICES';
}
export class GameStatusManager {
    public static GAMES_LISTED = 'GAMES_LISTED';
    public static GAME_GET = 'GAME_GET';
    public static GAME_BY_SPORT = 'GAME_BY_SPORT';
    public static LIST_GAME = 'LIST_GAME';
    public static GAME_BY_ID = 'GAME_BY_ID';
}

export class DefyStatusManager {
    public static CHALLENGES_LISTED = 'CHALLENGES_LISTED';
    public static DEFY_GET = 'CHALLENGES_GET';
    public static DEFY_BY_SPORT = 'CHALLENGES_BY_SPORT';
    public static LIST_DEFY = 'LIST_CHALLENGES';
    public static DEFY_BY_ID = 'CHALLENGES_BY_ID';
}

export class TeamStatusManager {
    public static TEAM_LISTED = 'TEAM_LISTED';
    public static TEAM_GET = 'TEAM_GET';
    public static TEAM_BY_SPORT = 'TEAM_BY_SPORT';
    public static LIST_TEAM = 'LIST_TEAM';
    public static TEAM_BY_ID = 'TEAM_BY_ID';
}

export class ClubStatusManager {
    public static CLUB_LISTED = 'CLUB_LISTED';
    public static CLUB_GET = 'CLUB_GET';
    public static CLUB_BY_SPORT = 'CLUB_BY_SPORT';
    public static LIST_CLUB = 'LIST_CLUB';
    public static CLUB_BY_ID = 'CLUB_BY_ID';
    public static CLUB_SLOTS_AVAILABLE_SUCCESS = 'CLUB_SLOTS_AVAILABLE_SUCCESS';
}

export class CommuneStatusManager {
    public static COUNTIES_LISTED = 'COUNTIES_LISTED';
    public static COUNTIES_GET = 'COUNTIES_GET';
    public static COUNTIES_BY_ID = 'COUNTIES_BY_ID';
}

export class RegionStatusManager {
    public static REGIONS_LISTED = 'REGIONS_LISTED';
    public static REGION_GET = 'REGION_GET';
    public static REGION_BY_SPORT = 'REGION_BY_SPORT';
    public static LIST_REGION = 'LIST_REGION';
    public static REGION_BY_ID = 'REGION_BY_ID';
}

export class ProfileStatusManager {
    public static PROFILES_LISTED = 'PROFILES_LISTED';
    public static PROFILE_GET = 'PROFILE_GET';
    public static PROFILE_BY_SPORT = 'PROFILE_BY_SPORT';
    public static LIST_PROFILE = 'LIST_PROFILE';
    public static USER_PROFILE_GET = 'USER_PROFILE_GET';
}

export class RankingStatusManager {
    public static RANKINGS_LISTED = 'RANKINGS_LISTED';
    public static RANKING_GET = 'RANKINGS_GET';
    public static RANKING_BY_SPORT = 'RANKINGS_BY_SPORT';
    public static LIST_RANKING = 'LIST_RANKINGS';
    public static RANKING_BY_ID = 'RANKINGS_BY_ID';
}
